<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'NullLayout',
    };
</script>

<style scoped></style>
